import React from 'react';
import { Instagram, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

// WhatsApp SVG Icon
const WhatsAppIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-white relative overflow-hidden" style={{ background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0f0f0f 100%)' }}>
      <div className="absolute inset-0 wavy-lines-dark opacity-30"></div>
      <div className="absolute inset-0 dots-dark opacity-20"></div>

      <div className="container mx-auto px-4 lg:px-8 py-12 relative z-10">
        <div className="flex flex-col items-center text-center space-y-8">
          {/* Logo */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_cdclean/artifacts/fd0170b0_Ads%C4%B1z%20tasar%C4%B1m%20%2813%29.png"
              alt="C&D Clean Logo"
              className="h-24 w-auto mb-4 mx-auto"
              style={{
                filter: 'drop-shadow(0 0 15px rgba(0, 212, 255, 0.4))'
              }}
            />
            <p className="text-sm text-gray-400 leading-relaxed max-w-md mx-auto">
              Profesyonel temizlikte dijital güvenceniz. Kalite, hız ve güven.
            </p>
          </div>

          {/* İletişim Bilgileri - Düzenli Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-3xl">
            {/* Telefon */}
            <a 
              href={`tel:${contactInfo.phone.replace(/\s/g, '')}`}
              className="flex items-center justify-center gap-2 px-6 py-4 neon-card rounded-lg hover:scale-105 transition-all"
            >
              <Phone className="w-5 h-5 text-neon-blue" />
              <span className="text-white font-semibold text-sm">{contactInfo.phone}</span>
            </a>

            {/* WhatsApp */}
            <a 
              href={contactInfo.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-6 py-4 bg-green-600/20 border-2 border-green-500/30 rounded-lg hover:scale-105 transition-all hover:bg-green-600/30"
              style={{
                boxShadow: '0 0 15px rgba(34, 197, 94, 0.3)'
              }}
            >
              <WhatsAppIcon className="w-5 h-5 text-green-400" />
              <span className="text-green-400 font-semibold text-sm">WhatsApp</span>
            </a>

            {/* Instagram */}
            <a 
              href={`https://instagram.com/${contactInfo.instagram}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 px-6 py-4 neon-card rounded-lg hover:scale-105 transition-all"
            >
              <Instagram className="w-5 h-5 text-neon-blue" />
              <span className="text-white font-semibold text-sm">@{contactInfo.instagram}</span>
            </a>
          </div>
        </div>

        {/* Telif Hakkı - Düzenli */}
        <div className="border-t border-neon-blue/20 mt-10 pt-6 text-center">
          <p className="text-sm text-gray-400 font-medium">
            © {currentYear} C&D Clean. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;